var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCashBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.29166 17.5C7.63683 17.5 7.91666 17.2202 7.91666 16.875C7.91666 16.5298 7.63683 16.25 7.29166 16.25C6.94648 16.25 6.66666 16.5298 6.66666 16.875C6.66666 17.2202 6.94648 17.5 7.29166 17.5Z",
    fill: "#131313"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.20834 17.5C5.55352 17.5 5.83334 17.2202 5.83334 16.875C5.83334 16.5298 5.55352 16.25 5.20834 16.25C4.86317 16.25 4.58334 16.5298 4.58334 16.875C4.58334 17.2202 4.86317 17.5 5.20834 17.5Z",
    fill: "#131313"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.125 17.5C3.47018 17.5 3.75 17.2202 3.75 16.875C3.75 16.5298 3.47018 16.25 3.125 16.25C2.77982 16.25 2.5 16.5298 2.5 16.875C2.5 17.2202 2.77982 17.5 3.125 17.5Z",
    fill: "#131313"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.95834 7.2915H12.0833C14.7296 7.2915 16.875 9.43692 16.875 12.0832C16.875 14.7294 14.7296 16.8748 12.0833 16.8748H9.37501",
    stroke: "#131313",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.29167 3.125L3.125 7.29167L7.29167 11.4583",
    stroke: "#131313",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashBackIcon);
export default __webpack_public_path__ + "static/media/cash-back-icon.0cf9db903bf9efe3d4116b24e61762ba.svg";
export { ForwardRef as ReactComponent };